import React from 'react';

const CareersValues: React.FC = () => {
  const values = [
    {
      icon: '🤝',
      title: 'Collaborative builders',
      description: 'We believe great solutions emerge when diverse minds work together, sharing knowledge and supporting each other\'s growth.'
    },
    {
      icon: '📚',
      title: 'Continuous learners',
      description: 'In a rapidly evolving tech landscape, we embrace curiosity and invest in learning new skills, technologies, and methodologies.'
    },
    {
      icon: '🔧',
      title: 'Problem solvers',
      description: 'We tackle complex challenges with creativity and persistence, finding innovative solutions that make a real difference.'
    },
    {
      icon: '🚀',
      title: 'Entrepreneurial mindset',
      description: 'We think like owners, take initiative, and aren\'t afraid to experiment with new ideas that can transform how we work and learn.'
    }
  ];

  return (
    <section className="careers-section careers-values">
      <div className="container">
        <h2 className="section-title">What we value</h2>
        <p className="section-subtitle">Our core values guide how we work, learn, and grow together.</p>
        
        <div className="values-grid">
          {values.map((value, index) => (
            <div key={index} className="value-card">
              <div className="value-icon">{value.icon}</div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CareersValues;